/**
 * convertDateTimeToTimestamp
 *
 * Converts a given date and time into a UTC timecode
 *
 * @return {}
 */

OT.createNS('OT.Search.Helpers.convertDateTimeToTimestamp');

OT.Search.Helpers.convertDateTimeToTimestamp = function(date, time) {

    var dateFormat = Resources.Strings.DateFormat.toUpperCase().replace(/\//g, '-') + ' HH:mm';

    time = OT.Search.Helpers.convertTimeTo24Hour(time);

    var datetime = date.replace(/\//g, '-') +' '+ time;

    return moment(datetime, dateFormat).format('X');
};
